import React from 'react';
import Page from '../../components/Page/Page';
import seo from '../../constants/seo';

const LodgeOwner = () => (
  <Page {...seo.lodgeOwner}>
    <h2 className="mt-0 pt-0">LODGE OWNERS</h2>
    <p className="mb-1">Namaste,</p>
    <p>
      HoneyGuide understands that you are tired of giving out free rooms, interested in
      getting direct bookings, and unsure of how to increase your digital presence. And we
      are here to help.
    </p>
    <p>
      If you run a hotel, lodge, or homestay in the Himalayas, joining HoneyGuide will help
      you:
      <ol>
        <li>Get more Trekkers by increasing the online presence of your Lodge.</li>
        <li>Manage the Reputation of your lodge through Reviews and Ratings.</li>
        <li>Use HoneyGuide’s Online Payment Gateway to Confirm Payments from Trekkers.</li>
        <li>Manage All your Bookings from all Channels Easily.</li>
      </ol>
    </p>
    <p>
      Some of the key features of working with HoneyGuide are:
      <ol>
        <li>A nominal 15 percent Service Fee on bookings.</li>
        <li>Easy to use Property and Booking Management System.</li>
        <li>Quick and Hassle-free Payments.</li>
        <li>
          Pay only 5 percent service fee for bookings that you get from your own contacts.
        </li>
      </ol>
    </p>
    <p>
      HoneyGuide is already working with 100+ lodges in Everest, 35+ Guides, and 1 Airline.
      Join the growing fraternity of lodges in the Himalayas:
    </p>
    <p>
      If you have any questions, please contact: <br />
      Ashish Shrestha <br />
      +977-9841370673 <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">honeyhunter@honeyguideapps.com</a>
    </p>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSc3cPXNJyiz7z4n0U-LwnTsl-79TtBqj6m28H51YhUuKxEZ-Q/viewform?embedded=true"
      width="100%"
      height="1180"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Lodge Owner"
    >
      Loading...
    </iframe>

    <p>
      <strong>About HoneyGuide</strong> <br />
      HoneyGuide is a technology company that helps men and mountains meet more often. While
      we go about it, we are constantly guided by our belief that:
      <ol>
        <li>
          Providing Trekkers with No-strings attached and Accurate Information will make our
          mountains safer and help more people enjoy the thrills of a rarefied atmosphere.
        </li>
        <li>A Trekker should have the power to run a trek the way she sees fit easily.</li>
        <li>
          Connecting Local Service Providers with Trekkers will lead to a more equitable
          distribution of tourism dividends and increase service levels faster.
        </li>
      </ol>
    </p>
  </Page>
);

export default LodgeOwner;



// WEBPACK FOOTER //
// ./src/screens/Partners/LodgeOwner.jsx